module.exports = __webpack_public_path__ + "img/weeare-dark.06d96f1f.png";